// When the user makes modifications to the notes of the order history.
export default function handleNotesChange(e, setOrderNote) {
  // Sets the new value.
  const value = e.target.value;
  // Updaes the notes hook.
  setOrderNote(value);
}
